import {Vector3} from 'three'
import * as THREE from 'three'

/**
 * Константы для OrbLoader
 * Централизованное хранение всех магических значений
 */
export const ORB_CONSTANTS = {
  // Модели орбов
  ORB_MODEL_NAMES: ['Gold', 'Iron', 'Oil', 'Silver', 'Titan'] as const,

  // Геометрия базового орба
  BASE_ORB_GEOMETRY_RADIUS: 1.5,
  BASE_ORB_GEOMETRY_SEGMENTS: 64,

  // Геометрия внешней сферы
  OUTER_SPHERE_RADIUS: 0.3,
  OUTER_SPHERE_SEGMENTS: 64,
  OUTER_SPHERE_SCALE: 6.1,

  // Геометрия внутренней сферы
  INNER_SPHERE_RADIUS: 2,
  INNER_SPHERE_SEGMENTS: 32,

  // Геометрия hitbox
  HITBOX_SIZE: 4,

  // Масштабы
  BASE_ORB_SCALE: 1.2,
  ORB_ALTITUDE: 5,
  ORB_SCALE: 30,
  PREVIEW_ORB_ALTITUDE: 5,
  PREVIEW_ORB_SCALE: 10,

  // Масштаб загружаемых моделей
  MODEL_SCALE_X: -10,
  MODEL_SCALE_Y: 10,
  MODEL_SCALE_Z: 10,

  // Смещения
  TOP_MODELS_HEIGHT_OFFSET: 3,

  // Анимация
  TIME_OFFSET_RANGE: 10,
  OUTER_TIME_OFFSET_RANGE: 100,

  // Цвета по уровням
  LEVEL_COLORS: {
    1: new Vector3(0.0, 0.41, 0.75), // Синий
    2: new Vector3(0.41, 0.75, 0.0), // Зеленый
    3: new THREE.Color(2.8, 0.2, 0.1), // Оранжевый (по умолчанию)
  },

  // Uniforms по умолчанию
  DEFAULT_COLOR_ADJUST: new Vector3(0.0, 0.41, 0.75),

  // Торнадо (смерч)
  TORNADO_TOP_RADIUS: 1.5,
  TORNADO_BOTTOM_RADIUS: 0.1,
  TORNADO_HEIGHT: 6,
  TORNADO_SEGMENTS: 32,
  TORNADO_POSITION_Y: -4.0,
  TORNADO_LIGHTNING_TOP_RADIUS: 1.52,
  TORNADO_LIGHTNING_BOTTOM_RADIUS: 0.11,
  TORNADO_LIGHTNING_HEIGHT: 6,
  TORNADO_LIGHTNING_SEGMENTS: 32,

  // Батарейка
  BATTERY_GROUP_POSITION_Y: 5.5,
  BATTERY_SHELL_RADIUS: 0.3,
  BATTERY_SHELL_HEIGHT: 1.2,
  BATTERY_SHELL_SEGMENTS: 16,
  BATTERY_CAP_RADIUS: 0.64,
  BATTERY_CAP_HEIGHT: 0.2,
  BATTERY_CAP_SEGMENTS: 16,
  BATTERY_CAP_Y_OFFSET: 1.2,
  BATTERY_CHARGE_BAR_RADIUS: 0.44,
  BATTERY_CHARGE_BAR_HEIGHT: 2,
  BATTERY_CHARGE_BAR_SEGMENTS: 16,
  BATTERY_SHELL_COLOR: 0xffffff,
  BATTERY_SHELL_OPACITY: 0.15,
  BATTERY_CAP_COLOR: 0x555555,
  BATTERY_CHARGE_COLOR: 0x00ffff,
  BATTERY_CHARGE_OPACITY: 0.7,

  // Анимация вспышек молнии
  FLASH_INITIAL_INTENSITY: 2.5,
  FLASH_DECAY_RATE: 0.04,
  FLASH_MIN_INTERVAL: 3.0,
  FLASH_MAX_INTERVAL: 5.0,
  CHARGE_ANIMATION_SPEED: 0.7,
} as const
